module.exports = __webpack_public_path__ + "static/media/5.41ddde88.JPG";